<template>
  <div class="storeAuth" v-loading="loading">
    <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
    <div class="content">
      <div class="clearfix">
        <div class="con_form">
          <el-form :model="authForm" ref="authForm" label-width="130px">
            <el-form-item label="企迈云商账号："><span class="account_num">{{phone}}</span></el-form-item>
            <el-form-item label="选择店铺：">
              <el-select v-model="authForm.shop" placeholder="请选择店铺">
                <el-option v-for="item in authForm.shopList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="protocol clearfix">
                <label>
                  <input type="checkbox" v-model="authForm.is_agree">
                  <span>同意</span>
                  <router-link to="/agreement.html"><span class="forget" style="color:#f7b205;">《企迈云商用户授权服务协议》</span></router-link>
                </label>
              </div>
            </el-form-item>
            <el-form-item label-width="0">
              <div class="yellow-btn" @click="confirmAuth">确认授权</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="arrow">
          <img src="static/img/arrow.png" alt="">
        </div>
        <div class="con_right">
          <p class="tit">您的店铺正在授权</p>
          <div class="shop_img">
            <div class="pic_item"><img src="/static/img/userImg.jpg" alt=""></div>
            <div class="shop_name">企迈云商</div>
            <!-- <div class="more">
              <el-popover
                placement="bottom-start"
                width="300"
                v-model="visible2">
                <p>企迈云将获取以下权限</p>
                <div>
                  <span>商品API</span>
                  <span>用户API</span>
                </div>
                <img src="/static/img/more.png" alt="" slot="reference" @click="visible2 = !visible2">
              </el-popover>
            </div>             -->
          </div>
          <p class="bot">企迈云与企迈云商平台深度对接，商家可便捷 获取平台提供的数据，以满足不同的业务场景。</p>
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <login-footer :description="desc"></login-footer>

  </div>
</template>

<script>
// 头部模块
import loginHeader from '../header'
// 底部模块
import loginFooter from '../footer'
// 滑动验证模块
import qs from 'qs'
let myDate = new Date()
const localYear = myDate.getFullYear()
export default {
  name: 'login',

  // 导入子组件
  components: {
    loginHeader, // 头部模块
    loginFooter // 底部模块
  },

  data() {
    return {
      loading: true,
      visible2: false,
      phone: '', // 企迈云商账号
      headerInfo: {
        type: '店铺授权',
        userDisplayFlag: true,
        userName: '',
        logo: 'https://img-shop.qmimg.cn/s16/images/2019/06/18/d76b9262c466ba5d.png'
      },
      desc: `<p><a href="https://www.qmai.cn" target="_blank">安徽智迈科技股份有限公司</a> 版权所有 Copyright 2009-${localYear} 皖公网安备34019202000074号&nbsp; 增值电信业务经营许可证：皖B2-20170075</p>`,
      // <p><img width="11px" src="https://img-shop.qmimg.cn/public/img/ico_safe.png"/>&nbsp;通过ISO27001:2013 信息安全认证通过ISO9001:2008质量管理体系认证</p>
      authForm: {
        shop: '', // 选择的店铺
        shopList: [], // 店铺列表
        is_agree: true
      },
      business_grant_token: '' // 外部页面跳转回来的token
    }
  },
  created() {
    this.business_grant_token = this.$route.query.open_business_grant_token ? this.$route.query.open_business_grant_token : ''
    this.checkLog() // 检查是否登录
  },
  methods: {
    checkLog() { // 检查登录请求
      var that = this
      QM.apinew({
        url: '/seller/user/check-login',
        method: 'post',
        data: {},
        success: function (xdata) {
          that.phone = xdata.data.username // 获取用户名
          that.headerInfo.userName = xdata.data.username // 获取顶部导航右侧用户名显示
          that.getShopList()
        },
        error: function (xdata) {
          // 未登录跳转到登录页面
          that.loading = false
          that.$message.error(xdata.message)
          that.$router.push({ path: '/login.html', query: { open_business_grant_token: that.business_grant_token } })
        }
      })
    },
    getShopList() { // 请求店铺列表
      var that = this
      QM.apinew({
        url: '/seller/store/index',
        method: 'get',
        success: function (xdata) {
          that.loading = false
          that.authForm.shopList = xdata.data.stores
        },
        error: function (xdata) {
          that.loading = false
          that.$message.error(xdata.message)
        }
      })
    },
    confirmAuth() { // 确定授权
      if (!this.authForm.shop) {
        this.$message.error('请选择店铺')
        return
      }
      if (!this.authForm.is_agree) {
        this.$message.error('请同意企迈云商用户授权服务协议')
        return
      }
      // 请求
      this.loading = true
      var that = this
      QM.apinew({
        url: '/seller/open/auth-store',
        method: 'post',
        data: {
          store_id: that.authForm.shop,
          business_grant_token: that.business_grant_token
        },
        success: function (xdata) {
          that.loading = false
          window.location.href = xdata.data.call_back_url
        },
        error: function (xdata) {
          that.loading = false
          that.$message.error(xdata.message)
        }
      })
    },
    showMsgFromChild(data, loadingData) { // 点击退出当前账号
      this.loading = true
      localStorage.setItem('mobile', '') // 清除本地存储
      localStorage.setItem('mytoken', '')
      setTimeout(() => {
        this.loading = false
        this.$router.push({ path: '/login.html', query: { open_business_grant_token: this.business_grant_token } })
      }, 500)
    }
  }

}
</script>

<style scoped>
.content{
  padding: 80px 50px 0 70px;
}
.content .con_form{
  padding-top: 30px;
  width: 46%;
  float: left;
}
.content .con_form .account_num{
  color: #333;
}
.content .arrow{
  width: 14%;
  float: left;
  text-align: center;
  padding-top: 142px;
}
.content .con_form .protocol{
  padding: 0;
}
.yellow-btn{
  width: 100%;
  text-align: center;
  line-height: 50px;
}
.yellow-btn:hover{
  background: #fde36d;
}
.content .con_form >>> .el-form-item{
  margin-bottom: 35px;
}
.content .con_form >>> .el-form-item__label{
  font-size: 16px;
  color: #999;
}
.con_form >>> .el-select{
  width: 260px;
}
.content .con_right{
  width: 40%;
  float: right;
  background: #f7f7f7;
  padding: 50px 32px 120px 50px;
}
.con_right .tit{
  font-size: 16px;
  color: #333;
}
.con_right .bot{
  padding-top: 20px;
  font-size: 12px;
  line-height: 30px;
}
.con_right .shop_img{
  display: flex;
  align-items: center;
  padding-top: 20px;
}
.con_right .shop_img .more{
  margin-left: 10px;
  cursor: pointer;
  padding-top: 7px;
}
.con_right .shop_img .shop_name{
  margin-left: 10px;
  font-size: 16px;
  color: #f7b205;
}
.con_right .pic_item{
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
  padding-top: 12px;
}
.con_right .pic_item img{
  height: 35px;
  margin-right: 0;
}
</style>